import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest mb-2">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="shrink-0 inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}